export default __webpack_public_path__ + "static/media/ic-tbtc.e1fd4b9b.svg";